// AD-11 (AIR11) | Product quiz pop-up
//   control = no pop-up
//   v1      = the default quiz app's pop-up is removed, and the Airdog quiz opens after 12 seconds,
//             once per visitor
// The quiz itself is assets/airdog-quiz.js (loaded on every page; the nav and other buttons open it
// too). Opening it anywhere sets the ab_test_quiz_seen cookie, so this pop-up never fires for a
// visitor who already opened the quiz, including during these 12 seconds.
// Wrapped so its names can't collide with the other ad-XX.js scripts on the same page.
(function () {
	// 1. Create an invisible iframe to bypass the theme's silencer
	const iframe = document.createElement('iframe');
	iframe.style.display = 'none';
	document.body.appendChild(iframe);

	// 2. Steal its untouched console.log and warn functions
	const realLog = iframe.contentWindow.console.log;
	const realWarn = iframe.contentWindow.console.warn;

	window.gbEvents = window.gbEvents || [];

	function testCode() {
		(function initAirdogQuizABTest() {
			if (document.getElementById('airdog-ab-quiz-styles')) return;

			// 1. NEUTRALIZE THE DEFAULT QUIZ
			// Actively watch the DOM to destroy the default quiz and its invisible backdrops
			const cleanupObserver = new MutationObserver(() => {
				const defaultQuiz = document.getElementById('ps__widget_container');
				if (defaultQuiz) {
					// Find the highest-level wrapper (in case the app uses a separate overlay parent)
					const overlayWrapper = defaultQuiz.closest('[class*="overlay"], [class*="backdrop"], [id*="ps__"]') || defaultQuiz;
					overlayWrapper.remove();

					// Force unlock the body in case the default app added a scroll lock
					document.body.style.setProperty('overflow', '', 'important');
					document.documentElement.style.setProperty('overflow', '', 'important');
				}
			});
			cleanupObserver.observe(document.body, { childList: true, subtree: true });

			// HIDE DEFAULT QUIZ AS FALLBACK
			const styles = document.createElement('style');
			styles.id = 'airdog-ab-quiz-styles';
			styles.innerHTML = `
    #ps__widget_container {
      display: none !important;
    }
  `;
			document.head.appendChild(styles);

			// 2. TRIGGER THE QUIZ (12 seconds, once per visitor)
			function getCookie(name) {
				var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
				if (match) return match[2];
				return null;
			}

			if (!getCookie('ab_test_quiz_seen')) {
				setTimeout(function () {
					// Opened from the nav (or anywhere else) in the meantime
					if (getCookie('ab_test_quiz_seen')) return;
					if (!window.AirdogQuiz) {
						realWarn('AD-11: assets/airdog-quiz.js is not loaded, no quiz to open.');
						return;
					}
					window.AirdogQuiz.open({ source: 'AIR11 Product Quiz' });
				}, 12000);
			}
		})();
	}

	// --->  MANUAL A/B TEST RANDOMIZER <---
	(function () {
		const preview = false;

		// =========================================================================
		// ---> TEST TARGETING CONFIGURATION
		// =========================================================================
		const config = {
			// URL Filtering
			filterByUrls: false,
			allowedUrls: [
				'airdog-x5-home-air-purifier-1600-sq-ft',
				'airdog-x8-home-air-purifier-1000-sq-ft',
				'airdog-x3-home-air-purifier-215-sq-ft',
				'x1-air-purifier',
			], // Only fires if current URL contains one of these strings

			// Device Filtering
			allowMobile: true,
			allowDesktop: true,
		};

		// Helper: Check if current URL is allowed
		function isUrlAllowed() {
			if (!config.filterByUrls) return true;
			// Using .includes() ensures query parameters won't break the match
			return config.allowedUrls.some((url) => window.location.href.includes(url));
		}

		function isDeviceAllowed() {
			const mobileBreakpoint = 768;
			const isMobile = window.innerWidth < mobileBreakpoint;

			if (isMobile && !config.allowMobile) return false;
			if (!isMobile && !config.allowDesktop) return false;

			return true;
		}

		// Evaluate targeting before running test or preview logic
		if (!isUrlAllowed() || !isDeviceAllowed()) {
			realLog('Test skipped: Does not meet URL or Device targeting rules.');
			return; // Exit out of the A/B test wrapper entirely
		}
		// =========================================================================

		if (!preview) {
			// CHANGE PER TEST: letters, numbers and underscores only (GA4 rejects hyphens).
			// Drives both the cookie and the GA4 user property, e.g. "ab_AIR11".
			// Register "ab_" + testId in GA4 as a user-scoped custom dimension before launch.
			const testId = 'AIR11';
			const cookieName = 'ab_' + testId;

			// Helper to read cookies
			function getCookie(name) {
				const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
				return match ? match[2] : null;
			}

			// Check if user already has a variant cookie
			let variant = getCookie(cookieName);

			// If they are new, flip a coin (50/50 split) and assign them
			if (!variant) {
				variant = Math.random() < 0.5 ? 'control' : 'v1';

				// Write cookie so variant follows them everywhere (expires in 30 days)
				const date = new Date();
				date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
				document.cookie = cookieName + '=' + variant + ';expires=' + date.toUTCString() + ';path=/';
			}

			// =========================================================================
			// ---> SEND DIRECTLY TO GA4
			// =========================================================================
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				dataLayer.push(arguments);
			}

			gtag('set', 'user_properties', {
				[cookieName]: variant,
			});

			gtag('event', 'experiment_impression', {
				experiment_id: testId,
				experiment_variant: variant,
				send_to: 'G-Y4VGNLBJPF',
			});
			// =========================================================================

			// Run the visual changes
			if (variant === 'v1') {
				realLog('MANUAL TEST: Variation active');
				testCode();
			} else {
				realLog('MANUAL TEST: Control active');
			}

			// Send the page view goal (if you still have a separate tracker looking for gbEvents)
			window.gbEvents.push('Page View');
		} else if (window.location.href.includes('ad-11')) {
			realLog('%cPreview mode ACTIVE', "color: #F7F631; background-color:black; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;");
			testCode();
		}
	})();
})();
